// extracted by mini-css-extract-plugin
module.exports =  {"textArea":"ReadMore-ReadMore-textArea-bdfc399e","textAreaInner":"ReadMore-ReadMore-textAreaInner-e840cd9f","readMoreButton":"ReadMore-ReadMore-readMoreButton-ea9b8cd2"};